var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-no-data"},[_c('span',[_c('el-image',{attrs:{"src":require('@/assets/icon/no-data.png')}}),_c('em',[_vm._v(_vm._s(_vm.text || _vm.$t('notification.NoData')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }